import { createSlice } from '@reduxjs/toolkit';

export interface SettingsState {
  reloadNewsFeed: boolean;
  isMobile: boolean;
}

const initialState: SettingsState = {
  reloadNewsFeed: false,
  isMobile: false,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setReloadNewsFeed(state, action) {
      state.reloadNewsFeed = action.payload;
    },
    setIsMobile(state, action) {
      state.isMobile = action.payload;
    },
  },
});

export const { setReloadNewsFeed, setIsMobile } = settingsSlice.actions;

// Selectors
export const getReloadNewsFeed = (state: any) => state.settings?.reloadNewsFeed || false;
export const getIsMobile = (state: any) => state.settings?.isMobile || false;

export default settingsSlice.reducer;
